import APIClient from '../api.service';

export const AuthenticationProvider = {
  login,
  logout,
};

async function login(username, password, remember) {
  try {
    const user = await initiateLogin(username, password);

    if (user && user.access && user.access.token && user.refresh && user.refresh.token) {
      sessionStorage.setItem('accessToken', user.access.token);
      sessionStorage.setItem('refreshToken', user.refresh.token);
      // Reset the 401 reload guard (api.service.js): a fresh session must be
      // allowed to reload immediately if it hits a genuine 401, even when the
      // pre-login session expired less than 30s ago.
      sessionStorage.removeItem('authRedirectAt');
      if (remember) {
        localStorage.setItem('refreshToken', user.refresh.token);
      }
      return { ok: true, reason: null };
    }
    return { ok: false, reason: 'credentials' };
  } catch (error) {
    // The auth endpoint is exempt from the session-expiry interceptor
    // (api.service.js), so a wrong username/password now reaches us as a
    // rejection instead of a page reload. It is a 401 from a server that
    // answered fine — reporting "can't reach the server" for it would be a lie.
    if (error && error.response && error.response.status === 401) {
      return { ok: false, reason: 'credentials' };
    }
    return { ok: false, reason: 'network' };
  }
}

async function logout() {
  try {
    // Call API to invalidate tokens on server
    const apiClient = new APIClient();
    await apiClient.logout();

    return true;
  } catch (error) {
    // Handle different HTTP status codes
    if (error.status === 401) {
      console.log('Authentication failed - token was invalid/expired');
    } else if (error.status === 403) {
      console.log('Access forbidden - insufficient permissions');
    } else if (error.status === 500) {
      console.log('Server error occurred during logout');
    } else {
      console.log('Network or other error occurred:', error.message);
    }

    // Even if server logout fails, clear local tokens
    return false;
  } finally {
    // Clear all tokens from storage regardless of API success/failure
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
    localStorage.removeItem('refreshToken');

    // Reload page to trigger the login screen
    window.location.reload();
  }
}

async function initiateLogin(username, password) {
  let apiClient = new APIClient();
  let response = apiClient.login(username, password);
  return await response;
}
